import settingsApp from "./settings";
import httpApp from "./http";
import { useFollowerStore } from "@/stores/follower";
import { useGlobalFunctions } from "@/libs/globalFunctions";

import i18n from "@/i18n";
const { t, te } = i18n.global;

const { createLoading, openToast } = useGlobalFunctions();

const followerApp = {
	getFollowedIds: async (showLoading = false) => {
		const loading = await createLoading(t("pleaseWait"));
		if (showLoading) {
			loading.present();
		}
		const followerStore = useFollowerStore();
		return new Promise(function (resolve) {
			httpApp
				.sendGetRequest(
					settingsApp.getEndpointUrl("getCustomerFollowedSellersIds")
				)
				.then((response: any) => {
					if (
						!Object.prototype.hasOwnProperty.call(response, "error")
					) {
						const items = response.items;
						followerStore.setFollowed(items);
						resolve(response);
					} else {
						followerStore.setFollowed([]);
					}
					if (showLoading) {
						loading.dismiss();
					}
				})
				.catch(() => {
					if (showLoading) {
						loading.dismiss();
					}
				});
		});
	},

	addToFollowed: async (id: any, showLoading = false, silent = true) => {
		const loading = await createLoading(t("pleaseWait"));
		if (showLoading) {
			loading.present();
		}
		const followerStore = useFollowerStore();
		return new Promise(function (resolve, reject) {
			httpApp
				.sendPostRequest(
					settingsApp.getEndpointUrl("addSellerFollow"),
					{
						seller_id: id,
					}
				)
				.then((response: any) => {
					if (showLoading) {
						loading.dismiss();
					}
					if (
						!Object.prototype.hasOwnProperty.call(response, "error")
					) {
						const items = followerStore.followedIds;
						if (!items.includes(id)) {
							items.push(id);
						}
						followerStore.setFollowed(items);
						resolve(response);
					} else {
						if (!silent) {
							if (
								te("apiMessages.codes." + response.error.code)
							) {
								openToast(
									t(
										"apiMessages.codes." +
											response.error.code
									),
									"danger"
								);
							} else {
								openToast(response.error.message, "danger");
							}
						}
						reject(response);
					}
				})
				.catch((error) => {
					if (showLoading) {
						loading.dismiss();
					}
					reject(error);
				});
		});
	},

	removeFromFollowed: async (id: any, showLoading = false, silent = true) => {
		const loading = await createLoading(t("pleaseWait"));
		if (showLoading) {
			loading.present();
		}
		const followerStore = useFollowerStore();
		return new Promise(function (resolve, reject) {
			httpApp
				.sendPostRequest(
					settingsApp.getEndpointUrl("removeSellerFollow"),
					{
						seller_id: id,
					}
				)
				.then((response: any) => {
					if (showLoading) {
						loading.dismiss();
					}
					if (
						!Object.prototype.hasOwnProperty.call(response, "error")
					) {
						const items = followerStore.followedIds;
						if (!items.includes(id)) {
							items.push(id);
						}
						followerStore.setFollowed(items);
						resolve(response);
					} else {
						if (!silent) {
							if (
								te("apiMessages.codes." + response.error.code)
							) {
								openToast(
									t(
										"apiMessages.codes." +
											response.error.code
									),
									"danger"
								);
							} else {
								openToast(response.error.message, "danger");
							}
						}
						reject(response);
					}
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
};

export default followerApp;
